module.exports = __webpack_public_path__ + "static/media/WBN_B2B_Manufacturers_Buyers_Distributors_Exporters_Importers_Indonesia.6dd361fe.png";